import React from 'react'

import { Form, Col } from '_zari/core'

const EstadoFormGroup = ({ iValue }) => {
  return (
    <Form.Group>
      <Form.Label text='ESTADO' htmlFor='readonly-estado' sm={4} alignRightAt='sm' />
      <Col sm={8}>
        <Form.InputText id='readonly-estado' name='readonly-estado' disabled value={iValue} />
      </Col>
    </Form.Group>
  )
}

export default React.memo(EstadoFormGroup)
